"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function TheManifesto() {
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.1
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const dataCategories = [{
    id: 1,
    title: "ΠΡΟΣΩΠΙΚΗ ΤΑΥΤΟΠΟΙΗΣΗ",
    items: ["Ονοματεπώνυμο για την εγκυρότητα της κράτησης", "Διεύθυνση Email για την αποστολή επιβεβαίωσης", "Τηλέφωνο επικοινωνίας για επείγουσες ενημερώσεις"]
  }, {
    id: 2,
    title: "ΣΤΟΙΧΕΙΑ ΚΡΑΤΗΣΗΣ",
    items: ["Ημερομηνίες άφιξης και αναχώρησης", "Επιλεγμένο κατάλυμα και τύπος δωματίου", "Ειδικές προτιμήσεις ή απαιτήσεις διαμονής"]
  }, {
    id: 3,
    title: "ΤΕΧΝΙΚΑ ΔΕΔΟΜΕΝΑ",
    items: ["Διεύθυνση IP για την ασφάλεια των συναλλαγών", "Τύπος προγράμματος περιήγησης (Browser)", "Cookies για τη βελτιστοποίηση της εμπειρίας χρήστη"]
  }];
  return <section data-section-id="4124" id="ποια-δεδομένα-συλλέγουμε" className="relative bg-background text-foreground min-h-screen py-[120px] md:py-[200px] px-6 md:px-12 lg:px-20 overflow-hidden">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' /%3E%3C/svg%3E\")"
    }} />

      <div className="relative mx-auto max-w-[1400px]">
        <div ref={labelRef} className={`flex justify-start mb-12 md:mb-16 transition-all duration-700 ease-out ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"}`}>
          <span className="font-mono text-[12px] md:text-[14px] tracking-[0.3em] uppercase font-bold" style={{
          color: "var(--primary)"
        }}>
            02 / ΣΥΛΛΟΓΗ ΔΕΔΟΜΕΝΩΝ
          </span>
        </div>

        <h2 ref={headlineRef} className={`font-default font-bold uppercase leading-[1] tracking-[-0.04em] text-left mb-16 md:mb-24 transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
        fontSize: "clamp(40px, 8vw, 120px)",
        maxWidth: "900px"
      }}>
          ΠΟΙΑ ΔΕΔΟΜΕΝΑ <span style={{
          color: "var(--primary)"
        }}>ΣΥΛΛΕΓΟΥΜΕ</span> ΚΑΙ ΓΙΑΤΙ.
        </h2>

        <div ref={bodyRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 transition-all duration-1000 delay-200 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {dataCategories.map((category, i) => <div key={category.id} data-index={i} className="flex flex-col space-y-6">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-[2px]" style={{
              backgroundColor: "var(--primary)"
            }} />
                <h3 className="font-default font-bold text-[18px] md:text-[20px] tracking-tight uppercase">
                  {category.title}
                </h3>
              </div>
              
              <ul className="space-y-4">
                {category.items.map((item, idx) => <li key={idx} className="flex items-start space-x-3 group">
                    <div className="mt-1.5 w-1.5 h-1.5 shrink-0" style={{
                backgroundColor: "var(--primary)"
              }} />
                    <span className="font-default text-[16px] md:text-[18px] text-foreground/80 leading-relaxed">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="mt-24 md:mt-32">
          <Separator className="bg-primary/20 h-[1px]" />
          <p className="mt-8 font-mono text-[12px] uppercase tracking-widest text-muted-foreground">
            ΔΙΑΦΑΝΕΙΑ &mdash; ΑΣΦΑΛΕΙΑ &mdash; HOTELDEALS.GR
          </p>
        </div>
      </div>
    </section>;
}